import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { TextEditor } from './QuillTextEditor';

export default React.memo(({ field, updateContestDetails }) => {
  let { contest } = useSelector((state) => state.CMSEditContestReducer);

  const [editorValue, setEditorValue] = useState(contest[field] ?? '');

  useEffect(() => {
    setEditorValue(contest[field]);
  }, [field, contest]);

  return (
    <TextEditor
      key={field}
      value={editorValue}
      handleTextChange={(value) => {
        setEditorValue(value);
        updateContestDetails({ [field]: value });
      }}
    />
  );
});
